import React, { useCallback, useState } from 'react';
import DropdownWrapper from '@components/wrapper/DropdownWrapper';
import { AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import NeighborList from './NeighborList';
import IconButton from '@components/dataEntry/button/IconButton';
import { useCollection } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import { useNavigate } from 'react-router-dom';

const NeighborhoodBtnBox = styled.div`
  width: 100%;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 12px;

  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 101;
  backdrop-filter: blur(8px);

  background: var(--backgroundColor);
  border-top: 1px solid var(--lineColor);
`;
const IframeStyle = styled.div`
  iframe {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    z-index: 100;
  }
`;

type Props = {};
function NeighborhoodBtn({}: Props) {
  const navigate = useNavigate();
  const [neighborLink, setNeighborLink] = useState<string>('');
  const [showNeighborList, setShowNeighborList] = useState<boolean>(false);

  const { data } = useCollection<Ibanner>(CollectionPath.BANNER, {
    listen: true,
  });

  const handleGoBackMyHome = useCallback(() => {
    setNeighborLink('');
    navigate('');
  }, []);
  const handleGoNeighbor = useCallback(() => {
    if (!data) return;

    // 랜덤 링크 배정 ---------------
    const max = data.length;
    const randomIndex = Math.floor(Math.random() * max);

    const link = data[randomIndex] ? data[randomIndex].linkto : '';
    // --------------------

    if (link) setNeighborLink(link);
    // if (neighborLink) setShowPage(true);
  }, [neighborLink, data]);

  const handleGoNeighborLinksPage = useCallback(
    () => setShowNeighborList(!showNeighborList),
    [showNeighborList],
  );

  const handleOpenNewPage = useCallback(() => {
    window.open(neighborLink, '_blank', 'noreferrer');
  }, [neighborLink]);

  return (
    <>
      <NeighborhoodBtnBox>
        <IconButton
          tooltipDir="top"
          shape="default"
          size="sm"
          icon="Home14"
          onClick={handleGoBackMyHome}
          tooltip="홈 돌아가기"
        />

        <IconButton
          tooltipDir="top"
          shape="default"
          size="sm"
          icon="Person14"
          onClick={handleGoNeighbor}
          tooltip="랜덤 이웃 방문"
        />

        <IconButton
          tooltipDir="top"
          shape="default"
          size="sm"
          icon="List14"
          onClick={handleGoNeighborLinksPage}
          tooltip="이웃 리스트"
        >
          <AnimatePresence>
            {showNeighborList && (
              <DropdownWrapper
                direction="bottomLeft"
                handleClickOutside={() => {}}
                style={{ width: 300 }}
                maxHeight={500}
              >
                <NeighborList setNeighborLink={setNeighborLink} />
              </DropdownWrapper>
            )}
          </AnimatePresence>
        </IconButton>

        {neighborLink && (
          <IconButton
            tooltipDir="top"
            shape="default"
            size="sm"
            icon="Link14"
            onClick={handleOpenNewPage}
            tooltip="새 창에서 열기"
          />
        )}
      </NeighborhoodBtnBox>

      {neighborLink && (
        <IframeStyle>
          <iframe
            id="inlineFrameExample"
            title="Inline Frame Example"
            src={neighborLink}
          >
            <p>보안 상 표시할 수 없는 웹페이지 입니다.</p>
          </iframe>
        </IframeStyle>
      )}
    </>
  );
}

export default NeighborhoodBtn;
